import { Component, Input } from '@angular/core';

@Component({
  selector: 'error-subscript',
  templateUrl: './error-subscript.component.html',
  styleUrls: ['./error-subscript.component.scss']
})
export class ErrorSubscriptComponent {
  @Input() error?: string;
}
